const dataAbout = [
    {
        id: 1,
        title: 'Complete Game Development Pipeline',
        desc: 'Take your Project from concept to launch. We establish pipelines for programming, Concept art, 3D art, and finally Optimization.',
        class: 'active'
    },
    {
        id: 2,
        title: 'Game-Fi Consulting',
        desc: 'Adviseing projects on building a web3 game ecosystem including tokenomics, venture design, and growth/community design.',
    },
    {
        id: 3,
        title: 'Development Team Expansion',
        desc: 'A plugin team for gaming studios who need immediate extra capacity and talent. We have a talent poll of over 30 people to draw upon when needed.',
    },
]

export default dataAbout;